import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const buildings = [];
let selectedLocationId = undefined;
let selectedBuildingId = undefined;
let selectedFloorId = undefined;
let showAllLocations = true;
const idToEntity = {};
let userToImage = {};
const userDisplayNames = [];
let shouldDisplayExampleDataInfoPanel = true;
let shouldDisplayFloorViewInfoPanel = true;
let shouldDisplayFloorSelectionViewInfoPanel = true;

const statusBox = "none";

function getIdToEntityFromBuildings(bs) {
  const map = [];

  bs.forEach(b => {
    map[b.id] = b;
    b.floors.forEach(f => {
      map[f.id] = f;
      f.locations.forEach(l => {
        map[l.id] = l;
      });
    });
  });

  return map;
}

export default new Vuex.Store({
  state: {
    buildings,
    idToEntity,
    selectedBuildingId,
    selectedFloorId,
    selectedLocationId,
    showAllLocations,
    statusBox,
    userToImage,
    userDisplayNames,
    shouldDisplayExampleDataInfoPanel,
    shouldDisplayFloorViewInfoPanel,
    shouldDisplayFloorSelectionViewInfoPanel
  },
  mutations: {
    SET_BUILDINGS(state, newBuildings) {
      state.buildings = newBuildings;
      state.idToEntity = getIdToEntityFromBuildings(newBuildings);
    },
    addBuilding(state, building) {
      state.buildings.push(building);
    },

    SET_SELECTED_LOCATION_ID(state, newId) {
      console.log("setting new location id");
      state.selectedLocationId = newId;
    },
    SET_SELECTED_BUILDING_ID(state, newId) {
      state.selectedBuildingId = newId;
    },
    SET_SELECTED_FLOOR_ID(state, newId) {
      state.selectedFloorId = newId;
    },
    setShowAllLocations(state, newBoolean) {
      state.showAllLocations = newBoolean;
    },
    setStatusBox(state, newStatusBox) {
      state.statusBox = newStatusBox;
    },
    setUserToImage(state, newUserToImage) {
      state.userToImage = newUserToImage;
    },
    setUserDisplayNames(state, newUserDisplayNames) {
      state.userDisplayNames = newUserDisplayNames;
    },
    setShouldDisplayExampleDataInfoPanelToFalse(state) {
      state.shouldDisplayExampleDataInfoPanel = false;
    },
    setShouldDisplayFloorViewInfoPanelToFalse(state) {
      state.shouldDisplayFloorViewInfoPanel = false;
    },
    setShouldDisplayFloorSelectionViewInfoPanelToFalse(state) {
      state.shouldDisplayFloorSelectionViewInfoPanel = false;
    }
  },
  actions: {},
  getters: {
    selectedBuilding(state) {
      return state.idToEntity[state.selectedBuildingId];
    },
    selectedLocation(state) {
      return state.idToEntity[state.selectedLocationId];
    },
    selectedFloor(state) {
      return state.idToEntity[state.selectedFloorId];
    },
    statusBox(state) {
      return state.statusBox;
    },
    userToImage(state) {
      return state.userToImage;
    },
    userDisplayNames(state) {
      return state.userDisplayNames;
    },
    shouldDisplayExampleDataInfoPanel(state) {
      return state.shouldDisplayExampleDataInfoPanel;
    },
    shouldDisplayFloorViewInfoPanel(state) {
      return state.shouldDisplayFloorViewInfoPanel;
    },
    shouldDisplayFloorSelectionViewInfoPanel(state) {
      return state.shouldDisplayFloorSelectionViewInfoPanel;
    }
  }
});
